<template>
  <Modal class="max-w-[300px]!" hide-close>
    <Modal.Body>
      <Spinner :size="30" class="mx-auto mb-2" />
      <div class="text-center text-[14px]">Processing your download...</div>
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { Modal, useModal } from '@dacr/library'
import Spinner from '@/shared/components/Spinner.vue'
import { useDownloadMutation } from '@/shared/graphql/legacy/generated'
import type { File } from '@/shared/graphql/router/graphql'
import { downloadURLContent } from '@/shared/utils/url'

const { close } = useModal()

const props = defineProps<{
  file: File
}>()

const { mutate: downloadFile } = useDownloadMutation()

onMounted(async () => {
  const result = await downloadFile({
    id: props.file.id,
  })

  const url = result?.data?.download

  if (!url) return

  downloadURLContent(props.file.metadata.originalFilename, url)

  close()
})
</script>
